import { useModalStore } from '@/stores/useModalStore'
import { ExportModal } from '@/components/modals/ExportModal'
import { RiDownloadLine } from 'react-icons/ri'
import styles from './ExportPanel.module.css'

export function ExportPanel() {
    const handleOpenExport = () => {
        useModalStore.getState().openModal(<ExportModal />)
    }

    return (
        <div className={styles.panel}>
            <h3 className={styles.title}>Exportar</h3>
            <p className={styles.hint}>
                Exporta tu diseño en PNG, JPG, PDF o SVG. Selecciona las páginas y la calidad.
            </p>
            <button className={styles.exportBtn} onClick={handleOpenExport}>
                <RiDownloadLine />
                Abrir opciones de exportación
            </button>
        </div>
    )
}
